import { DEMO_ROUTES } from "@/_old/constants/routes";
import { AxiosInstance, isAxiosError } from "axios";
import { getDemoResponseByUrl } from "../utils/demo-response-by-url";
import { parseDemoRequestUrl } from "../utils/parse-demo-request-url";

type DemoReponse<T> = {
  data: T;
};

export const DemoRequestInterceptor = (api: AxiosInstance) => {
  api.interceptors.request.use(
    (config) => {
      if (window.location.pathname.startsWith(DEMO_ROUTES.INDEX)) {
        const route = parseDemoRequestUrl(config.url!, config.method!);

        const demo: DemoReponse<any> = {
          data: getDemoResponseByUrl(route),
        };

        return Promise.reject(demo);
      }

      return config;
    },
    (error) => Promise.reject(error),
  );
};

/**
 * Converte em sucesso a rejeição que o `DemoRequestInterceptor` dispara com o
 * mock. Só age em rota de demo e em objeto sem cara de erro do axios — fora
 * disso o erro precisa continuar rejeitado, senão um 400 da API viraria
 * resposta de sucesso (com `data` undefined) no consumidor.
 */
export const DemoResponseInterceptor = (api: AxiosInstance) => {
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      const isDemoRoute = window.location.pathname.startsWith(
        DEMO_ROUTES.INDEX,
      );
      const isDemoMock =
        isDemoRoute && !isAxiosError(error) && !(error instanceof Error);

      return isDemoMock ? Promise.resolve(error) : Promise.reject(error);
    },
  );
};
